import { fetchGigyaJWTPromise } from 'api/gigya';
import logger from 'util/logger';

/**
 * connectionCode - code user enters in input fields, used for syncronizing with TV, in form of XXXX-XXXX
 * @retuns bool - return if connectionCode is valid or not
 */
const checkUserCode = async (userCode) => {
  try {
    const jwtToken = await fetchGigyaJWTPromise();
    const response = await fetch(process.env.REACT_APP_TV_CONNECT_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify({
        user_code: userCode,
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    const { message } = await response.json();
    return message === 'OK';
  } catch (error) {
    logger.error(error);
    return false;
  }
};

export default checkUserCode;
